import { api } from './client';

export interface Campaign {
  id: string;
  session_id: string;
  problem_statement_id: string | null;
  solution_idea_id: string | null;
  audience_segment_id: string | null;
  meta_campaign_id: string | null;
  meta_adset_id: string | null;
  meta_ad_id: string | null;
  status: string;
  objective: string;
  daily_budget_cents: number;
  headline: string;
  body_text: string;
  link_url: string | null;
  image_url: string | null;
  created_at: string;
  updated_at: string;
  // Insights (populated after sync)
  impressions?: number;
  clicks?: number;
  spend?: number;
  ctr?: number;
  reach?: number;
  cpc?: number;
}

export interface AudienceSegment {
  id: string;
  session_id: string;
  problem_statement_id: string | null;
  name: string;
  description: string | null;
  targeting_spec: unknown;
  estimated_reach: number | null;
  created_at: string;
}

export async function listCampaigns(
  sessionId: string
): Promise<Campaign[]> {
  return api.get(`/meta-ads/campaigns?session_id=${sessionId}`);
}

export async function getCampaign(id: string): Promise<Campaign> {
  return api.get(`/meta-ads/campaigns/${id}`);
}

export async function createCampaign(data: {
  session_id: string;
  problem_statement_id?: string;
  solution_idea_id?: string;
  audience_segment_id: string;
  headline: string;
  body_text: string;
  link_url?: string;
  daily_budget_cents: number;
  target_countries?: string[];
  target_age_min?: number;
  target_age_max?: number;
  objective?: string;
  image_url?: string;
  canva_auto_generate?: boolean;
}): Promise<Campaign> {
  return api.post('/meta-ads/validate', data);
}

export async function activateCampaign(id: string): Promise<Campaign> {
  return api.post(`/meta-ads/campaigns/${id}/activate`);
}

export async function pauseCampaign(id: string): Promise<Campaign> {
  return api.post(`/meta-ads/campaigns/${id}/pause`);
}

export async function syncCampaign(id: string): Promise<Campaign> {
  return api.post(`/meta-ads/campaigns/${id}/sync`);
}

export async function listAudienceSegments(
  sessionId: string
): Promise<AudienceSegment[]> {
  return api.get(`/audience-segments?session_id=${sessionId}`);
}

export async function generateAudienceSegments(data: {
  session_id: string;
  problem_statement_id?: string;
}): Promise<AudienceSegment[]> {
  return api.post('/audience-segments/generate', data);
}
